/* =========================================================
   FSR Blog – Interaktionen & Anreicherung der Blog-Bausteine

   Übernimmt automatisch (das Gem schreibt nur simples Markup):
     - FAQ:      <div>-Fragen -> Buttons + Chevron, Akkordeon,
                 automatisches FAQPage-JSON-LD (Rich Result)
     - Tabellen: Scroll-Wrapper ergänzen (horizontal scrollbar auf Mobile)
     - Vergleich: hervorgehobene Spalte (is-featured) auf alle Zellen ziehen

   Der CTA-Button-Pfeil kommt vollständig aus dem Theme
   (.fsr-skyvault-button-arrow) – dieses Script fügt bewusst
   KEINEN Pfeil mehr ein (sonst Doppel-Pfeil).
   ========================================================= */
(function () {
'use strict';

var CHEVRON =
'<span class="fsr-blog-faq-chevron" aria-hidden="true">' +
'<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
'<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" ' +
'stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

var GOOGLE =
'<svg class="fsr-blog-google" xmlns="http://www.w3.org/2000/svg" ' +
'viewBox="0 0 48 48" aria-hidden="true">' +
'<path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>' +
'<path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>' +
'<path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>' +
'<path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>' +
'</svg>';

function debounce(fn, wait) {
var t;
return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  }


/* ---------------- FAQ ---------------- */
function initFaq(root) {
if (root.dataset.fsrFaqReady) return;
var items = root.querySelectorAll('.fsr-blog-faq-item');
if (!items.length) return;
root.dataset.fsrFaqReady = '1';

var buttons = [];

items.forEach(function (item) {
var q = item.querySelector('.fsr-blog-faq-q');
var a = item.querySelector('.fsr-blog-faq-a');
if (!q || !a) return;

// Antwort-Inhalt in Inner-Wrapper (Layout) + Theme-Typografie
if (!a.querySelector('.fsr-blog-faq-a-inner')) {
var inner = document.createElement('div');
inner.className = 'fsr-blog-faq-a-inner fsr-skyvault-text';
while (a.firstChild) inner.appendChild(a.firstChild);
a.appendChild(inner);
      }

// Frage-<div> in echten <button> umwandeln (a11y + Tastatur)
var btn = document.createElement('button');
btn.type = 'button';
btn.className = 'fsr-blog-faq-q';
btn.setAttribute('aria-expanded', 'false');

var label = document.createElement('span');
label.className = 'fsr-skyvault-text';
while (q.firstChild) label.appendChild(q.firstChild);

btn.appendChild(label);
btn.insertAdjacentHTML('beforeend', CHEVRON);
q.parentNode.replaceChild(btn, q);

buttons.push(btn);

btn.addEventListener('click', function () {
var isOpen = btn.getAttribute('aria-expanded') === 'true';
buttons.forEach(function (other) {
if (other !== btn) setFaqState(other, false);
        });
setFaqState(btn, !isOpen);
      });
    });

// Ab jetzt einklappen (vorher waren Antworten als Fallback sichtbar)
root.classList.add('fsr-blog-faq--enhanced');
  }

function setFaqState(btn, open) {
var a = btn.parentNode.querySelector('.fsr-blog-faq-a');
btn.setAttribute('aria-expanded', open ? 'true' : 'false');
if (!a) return;
a.style.maxHeight = open ? a.scrollHeight + 'px' : null;
  }

var onResize = debounce(function () {
document.querySelectorAll('.fsr-blog-faq-q[aria-expanded="true"]').forEach(function (btn) {
var a = btn.parentNode.querySelector('.fsr-blog-faq-a');
if (a) a.style.maxHeight = a.scrollHeight + 'px';
    });
  }, 150);

// Automatisches FAQPage-JSON-LD aus dem (noch reinen) Q/A-Markup
function buildFaqSchema() {
var items = document.querySelectorAll('.fsr-blog-faq .fsr-blog-faq-item');
if (!items.length) return;

var entities = [];
items.forEach(function (item) {
var q = item.querySelector('.fsr-blog-faq-q-text') || item.querySelector('.fsr-blog-faq-q');
var a = item.querySelector('.fsr-blog-faq-a-inner') || item.querySelector('.fsr-blog-faq-a');
if (!q || !a) return;
var name = (q.textContent || '').replace(/\s+/g, ' ').trim();
var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
if (!name || !text) return;
entities.push({
'@type': 'Question',
'name': name,
'acceptedAnswer': { '@type': 'Answer', 'text': text }
      });
    });
if (!entities.length) return;

var script = document.createElement('script');
script.type = 'application/ld+json';
script.textContent = JSON.stringify({
'@context': 'https://schema.org',
'@type': 'FAQPage',
'mainEntity': entities
    });
document.head.appendChild(script);
  }


/* ---------------- Tabellen: Scroll-Wrapper ---------------- */
function wrapTables() {
document.querySelectorAll('.fsr-blog-table, .fsr-blog-compare').forEach(function (table) {
if (table.closest('.fsr-blog-table-wrap')) return;
var wrap = document.createElement('div');
wrap.className = 'fsr-blog-table-wrap';
table.parentNode.insertBefore(wrap, table);
wrap.appendChild(table);
    });
  }


/* ---------------- Vergleich: hervorgehobene Spalte ---------------- */
function markFeaturedColumns() {
document.querySelectorAll('.fsr-blog-compare').forEach(function (table) {
var headers = table.querySelectorAll('thead th');
var idx = -1;
headers.forEach(function (th, i) { if (th.classList.contains('is-featured')) idx = i; });
if (idx < 0) return;
table.querySelectorAll('tbody tr').forEach(function (tr) {
var cell = tr.children[idx];
if (cell) cell.classList.add('is-featured');
      });
    });
  }


/* ---------------- Byline: Google-Logo ---------------- */
function decorateByline() {
document.querySelectorAll('.fsr-blog-byline-reviews').forEach(function (el) {
if (el.querySelector('.fsr-blog-google')) return;
el.insertAdjacentHTML('afterbegin', GOOGLE);
    });
  }


/* ---------------- Boot ---------------- */
function boot() {
// FAQ zuerst: Schema aus reinem Markup lesen, dann DOM aufrüsten
if (document.querySelector('.fsr-blog-faq')) {
buildFaqSchema();
document.querySelectorAll('.fsr-blog-faq').forEach(initFaq);
window.addEventListener('resize', onResize);
    }
markFeaturedColumns();
wrapTables();
decorateByline();
  }

if (document.readyState !== 'loading') boot();
else document.addEventListener('DOMContentLoaded', boot);
})();
